import { FC } from 'react';
import _ from 'lodash';
import GalleryHeader from '../GalleryHeader';
import { TemplateGalleryCard } from '@common/types';
import s from './GalleryGrid.module.scss';
import TemplateCardListItems from '../TemplateCardListItems';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';

type Props = {
  templates?: TemplateGalleryCard[];
  count?: number;
};
const GalleryGrid: FC<Props> = ({ templates, count }) => {
  const {
    state: { filterOpen },
  } = useTemplatesContext();

  return (
    <div className={s.gridContainer}>
      <GalleryHeader className={s.header} templateCount={count} />
      <ul className={`${s.content} ${filterOpen ? '' : s.filterClosed}`}>
        <TemplateCardListItems templates={templates} isMobileView={false} />
      </ul>
    </div>
  );
};

export default GalleryGrid;
